import { create } from "zustand"

/**
 * Shared UI state of the upload retry action.
 *
 * Lifecycle: `startRetry` on the user's click (refused while one is already running, so
 * repeated taps do nothing), cleared by the uploader on its next cycle.
 */
type UploadUiState = {
  isRetrying: boolean
  /** Returns false when a retry is already in flight. */
  startRetry: () => boolean
  stopRetry: () => void
}

export const useUploadUiStore = create<UploadUiState>((set, get) => ({
  isRetrying: false,
  startRetry: () => {
    if (get().isRetrying) return false

    set({ isRetrying: true })
    return true
  },
  stopRetry: () => set({ isRetrying: false }),
}))
